import Costs from '../CostsOverview.vue';

export default {
  path: '/costs',
  name: 'Costs',
  component: Costs,
  meta: { menuItemName: 'Costs' }
};
